import woodConnectionDefaultOptions from './defaultOptions';
import WoodConnectionObject from './wood-connection.object';

export {
  WoodConnectionObject,
  woodConnectionDefaultOptions
}; 



// WEBPACK FOOTER //
// ./src/object-view/generators/wood-connection/index.js